// import Images from '../Pic';
import React from "react";
import Pictures from "../../../Pic";
import { Link } from "react-router-dom";
import "./Sec2.css";
function Sec2() {
  return (
    <section className="sec2 ">
      <div className="innerSec2">
        <h2 className="mainHeading"> A Closer Look at Creative Balloons </h2>
        <div className="introduction">
          <div className="para">
            <p>
              Creative Balloons is a trusted manufacturer and
              supplier of premium quality Inflatable Characters, Advertising
              Balloons, and other products. We have been in business since 2011,
              and our extensive range of products includes Advertising Air
              Dancers, Hot Air Shape Sky Balloons, Airship Sky Balloons, Back
              Pack Balloons, Android Walking Balloons, and Hanuman Ji Walking
              Inflatables, as well as Inflatable Arches, Inflatable Slide
              Bouncies, VIP Pizza Rubber Balloons, ACC Pole Balloons, Hanging
              Balloons, Sky Balloon Manufacturers in Hyderabad and many more.
            </p>
          </div>
          <div className="row">
            <div className="col">
              <img src={Pictures.sec2.img1} className="logo" alt="" />
              <h4 className="description">Nature of Business</h4>
              <p>Exporter and Manufacturer</p>
            </div>
            <div className="col">
              <img src={Pictures.sec2.img2} className="logo" alt="" />
              <h4 className="description">Total Number of Employees</h4>
              <p>11 to 25 People</p>
            </div>
            <div className="col">
              <img src={Pictures.sec2.img6} className="logo" alt="" />
              <h4 className="description">Annual Turnover</h4>
              <p>Rs. 1 - 2 Crore</p>
            </div>
            <div className="col">
              <img src={Pictures.sec2.img4} className="logo" alt="" />
              <h4 className="description">GST Number</h4>
              <p>07ASUPS1475R1ZI</p>
            </div>
            <div className="col">
              <img src={Pictures.sec2.img3} className="logo" alt="" />
              <h4 className="description">Import Export Code (IEC)</h4>
              <p>05130****</p>
            </div>
            <div className="col">
              <img src={Pictures.sec2.img5} className="logo" alt="" />
              <h4 className="description">Year of Establishment</h4>
              <p>1997</p>
            </div>

          </div>

          <div className="BtnPan">
            <Link to="/AboutUs" className="cta">view more</Link>
          </div>

        </div>

      </div>
    </section>
  );
}
export default Sec2;
